module.exports = __webpack_public_path__ + "img/NAVI-CamposLoval_Master_Home_V3.12--Recovered.8243d073.png";